import React from "react";
// import { LocalizationContext } from "../../../../../locales/Translation";
import SearchBar4Table from "../../../../../components/SearchBar4Table";
import { debounce } from "lodash";

type Props = {
  onSearch: any;
  placeholder?: any;
};

const Search = ({ onSearch, placeholder }: Props) => {
  // const { translations } = useContext(LocalizationContext);

  const debounceOnChange = debounce((e, { value }) => {
    onSearch(value);
  }, 500);

  return (
    <SearchBar4Table
      placeholder={placeholder ? placeholder : "Search by Market Name, Country"}
      onChange={debounceOnChange}
    />
  );
};

export default Search;
